'use client'

// React custom hook to get the current page and pathname
import {
  usePathname,
  useSelectedLayoutSegment,
  useSelectedLayoutSegments,
} from 'next/navigation'

export const usePagePath = () => {
  const segments = useSelectedLayoutSegments()
  const selectedSegment = useSelectedLayoutSegment()
  const pathname = usePathname()

  const getPageParent = () => {
    if (pathname === '/') {
      return 'dashboard'
    } else {
      return pathname.split('/')[1]
    }
  }

  const pageParent = getPageParent()

  return {
    pageParent,
    currentPage: segments[segments?.length - 1],
    grandParent: segments[0],
    parent: segments[segments?.length - 2],
    segments,
    segmentsCount: segments?.length,
    pathname,
    selectedSegment,
  }
}
